<template>
  <div @click="navToProviderProfile" class="row">
    <div class="col-12 col-md-4 col-lg-3 align-self-center">
      <div class="result-logo">
        <img :src="provider.logo" class=" mx-auto d-table" alt="" />
      </div>
    </div>
    <div class="col-12 col-md-8 col-lg-9 align-self-center">
      <div class="result-describe">
        <h4 class="result-heading">
          {{ this.provider.name }} <span>{{ providerTypesString }}</span>
        </h4>
        <p>
          Founded {{ this.provider.year_founded }}
          <a :href="this.provider.url">{{ this.provider.url }}</a>
        </p>
        <p v-if="!showMore" v-html="shortDesc"></p>
        <p v-else v-html="longDesc"></p>
        <div v-if="displayShowOption">
          <a v-if="!showMore" @click="toggleShowState" class="read-more"
            >See More</a
          >
          <a v-else @click="toggleShowState" class="read-more">See Less</a>
        </div>
        <ul>
          <li v-for="capitalType in capitalTypeList">
            {{ capitalType }}
            <img :src="require('../../assets/images/tick.png')" alt="" />
          </li>
          <div class="clearfix"></div>
        </ul>
      </div>
    </div></div
></template>

<script>
import slugify from "slugify";
import helper from "../../helper.js";

export default {
  name: "InvestorListItem",
  props: ["provider"],
  data: function() {
    return {
      showMore: false,
      requestShowNotNav: false
    };
  },
  computed: {
    displayShowOption: function() {
      return this.provider.description.length > 150;
    },
    shortDesc: function() {
      if (!this.displayShowOption) return this.longDesc;
      return `${this.formatDesc(
        this.provider.description.replace().substring(0, 150)
      )}...`;
    },
    longDesc: function() {
      return `${this.formatDesc(this.provider.description)}`;
    },
    providerTypesString: function() {
      if (this.provider.provider_provider_types == null) return "";
      var providerTypes = this.provider.provider_provider_types
        .filter(providerType => {
          return providerType.provider_type != null;
        })
        .map(providerType => {
          return providerType.provider_type.name;
        });
      if (providerTypes.length > 1) {
        var last = providerTypes.pop();
        providerTypes = `${providerTypes.join(", ")} & ${last}`;
        return providerTypes;
      } else {
        return providerTypes[0];
      }
    },
    capitalTypeList: function() {
      if (this.provider.provider_capital_types == null) return [];
      var capitalTypes = this.provider.provider_capital_types
        .filter(capitalType => {
          return capitalType.capital_type != null;
        })
        .map(capitalType => {
          return capitalType.capital_type.name;
        });
      return capitalTypes;
    }
  },
  methods: {
    formatDesc(str) {
      return helper.formatDesc(str);
    },
    navToProviderProfile() {
      if (!this.requestShowNotNav) {
        if (this.provider.hasOwnProperty("name")) {
          var urlParam = slugify(this.provider.name, { lower: true });
          this.$router.push({
            name: "Profile",
            params: { providerName: urlParam }
          });
        }
      } else {
        this.requestShowNotNav = false;
      }
    },
    toggleShowState() {
      this.showMore = !this.showMore;
      this.requestShowNotNav = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/directory/InvestorListItem.vue